/**
 * NEEMPOP Search JS — Predictive Search & Accessibility
 */
document.addEventListener('DOMContentLoaded', () => {
  const searchTriggers = document.querySelectorAll('[data-search-trigger]');
  const searchDrawer = document.querySelector('[data-search-drawer]');
  const searchBackdrop = document.querySelector('[data-search-backdrop]');
  const searchClose = document.querySelector('[data-search-close]');
  const searchInput = document.querySelector('[data-predictive-search-input]');
  const searchResultsContainer = document.querySelector('[data-predictive-search-results]');

  if (!searchDrawer) return;

  const openSearch = () => {
    searchDrawer.classList.add('is-active');
    if (searchBackdrop) searchBackdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 100);
    }
  };

  const closeSearch = () => {
    searchDrawer.classList.remove('is-active');
    if (searchBackdrop) searchBackdrop.classList.remove('is-active');
    document.body.style.overflow = '';
  };

  searchTriggers.forEach(btn => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openSearch();
  }));

  if (searchClose) searchClose.addEventListener('click', closeSearch);
  if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchDrawer.classList.contains('is-active')) {
      closeSearch();
    }
  });

  // Predictive search fetcher
  let debounceTimeout;
  if (searchInput && searchResultsContainer) {
    searchInput.addEventListener('input', () => {
      clearTimeout(debounceTimeout);
      const query = searchInput.value.trim();

      if (query.length < 2) {
        searchResultsContainer.innerHTML = '';
        return;
      }

      debounceTimeout = setTimeout(async () => {
        try {
          const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`);
          if (!res.ok) return;

          const data = await res.json();
          const products = data.resources.results.products || [];

          if (products.length === 0) {
            searchResultsContainer.innerHTML = `<p style="padding: 1rem; color: var(--np-muted);">No products found for "${query}"</p>`;
            return;
          }

          let html = '<div style="display: flex; flex-direction: column; gap: 0.75rem; padding-top: 1rem;">';
          products.forEach(prod => {
            html += `
              <a href="${prod.url}" style="display: flex; align-items: center; gap: 1rem; text-decoration: none; padding: 0.5rem; border-radius: var(--np-radius-sm); transition: background 0.2s;">
                <img src="${prod.image}" alt="${prod.title}" style="width: 50px; height: 50px; object-fit: cover; border-radius: var(--np-radius-sm);">
                <div>
                  <div style="font-weight: 700; color: var(--np-text); font-size: 0.95rem;">${prod.title}</div>
                  <div style="font-weight: 700; color: var(--np-accent); font-size: 0.9rem;">₹${(prod.price / 100).toFixed(0)}</div>
                </div>
              </a>
            `;
          });
          html += '</div>';

          searchResultsContainer.innerHTML = html;
        } catch (err) {
          console.error(err);
        }
      }, 300);
    });
  }
});
